var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":_vm.getPageTitle,"sub-pages":_vm.subPages}},[_c('router-view',{attrs:{"client-id":_vm.studyId,"client-name":_vm.study ? _vm.study.title : ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }